import { SessionStorageKey } from "./storageKeys";
import { RESTAURANT_MENU_COOKIE_PATHS } from "./constants";

export const getFromSessionStorage = <T>(
  key: SessionStorageKey,
  defaultValue: T
): T => {
  if (typeof window !== "undefined") {
    const itemFromStorage = global?.window?.sessionStorage.getItem(key);
    let item = null;
    try {
      if (itemFromStorage) {
        item = JSON.parse(itemFromStorage);
      }
    } catch {
      item = itemFromStorage;
    }
    return item ? item : defaultValue;
  } else {
    return defaultValue;
  }
};

export const saveToSessionStorage = <T>(key: SessionStorageKey, item: T) => {
  if (item) {
    global?.window?.sessionStorage.setItem(key, JSON.stringify(item));
  }
};

export const removeFromSessionStorage = (key: SessionStorageKey) =>
  global?.window?.sessionStorage.removeItem(key);

export const saveDayPartMenuCookie = <T>(item: T) => {
  if (typeof document === "undefined" || !item) return;

  for (const legacyPath of RESTAURANT_MENU_COOKIE_PATHS) {
    document.cookie = `daypartMenu=; Max-Age=0; Path=${legacyPath}`;
  }
  document.cookie = `daypartMenu=${encodeURIComponent(
    JSON.stringify(item)
  )}; Path=/`;
};
